import { jsx as _jsx } from "react/jsx-runtime";
import RelationGroupMultiSelect from '../multiselect/RelationGroupMultiSelect';
export var FilterRelationGroupMultiSelect = function (_a) {
    var _b;
    var item = _a.item, setFilter = _a.setFilter, activeFilters = _a.activeFilters, label = _a.label, isAlwaysVisible = _a.isAlwaysVisible, enabled = _a.enabled;
    return ({
        filterItem: item,
        filterSelectLabel: !isAlwaysVisible ? label : undefined,
        enabled: enabled,
        element: (_jsx(RelationGroupMultiSelect, { selection: (_b = activeFilters[item]) !== null && _b !== void 0 ? _b : [], onChange: function (value) {
                var _a;
                return setFilter((_a = {}, _a[item] = value !== null && value !== void 0 ? value : undefined, _a));
            }, placeholder: label })),
    });
};
